import { ref } from 'vue'

export interface PromptOptions {
  title: string
  message?: string
  defaultValue?: string
  confirmText?: string
  cancelText?: string
}

interface PromptState extends PromptOptions {
  visible: boolean
  resolve?: (value: string | null) => void
}

const promptState = ref<PromptState>({
  visible: false,
  title: '',
  defaultValue: '',
  confirmText: '确认',
  cancelText: '取消'
})

export function usePrompt() {
  const show = (options: PromptOptions): Promise<string | null> => {
    return new Promise((resolve) => {
      promptState.value = {
        ...options,
        visible: true,
        resolve
      }
    })
  }

  const confirm = (value: string) => {
    if (promptState.value.resolve) {
      promptState.value.resolve(value)
    }
    promptState.value.visible = false
  }

  const cancel = () => {
    if (promptState.value.resolve) {
      promptState.value.resolve(null)
    }
    promptState.value.visible = false
  }

  return {
    promptState,
    show,
    confirm,
    cancel
  }
}
